import React from 'react';
import PropTypes from 'prop-types';
import './Skeleton.scss';

const Skeleton = props => {
  const { className, style } = props;
  return <div className={`Skeleton ${className}`} style={style} />;
};

Skeleton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

Skeleton.defaultProps = {
  className: '',
  style: {},
};

export default Skeleton;
